import axios from '@/axios.js'
import state from './state';

export default { 
    fetchNewestNotifications({ commit, dispatch }, data) {
        state.isLoading = true;
        axios.get('/notifications/newest')
        .then(function (response) {
            if(response.status == 200) 
                commit('FETCH_NEWEST_NOTIFICATIONS', response.data);
            state.isLoading = false;
        })
        .catch(function (error) {
            state.isLoading = false;
        });
    },
    readNotifications({ commit, dispatch }, data) {
        state.isLoading = true;
        axios.post('/notifications/read', {
            notifications_ids: data.ids,
            next: data.next ? true : false
        })
        .then(function (response) { 
            if(response.status == 200)
                commit('FETCH_NEWEST_NOTIFICATIONS', response.data);
            state.isLoading = false;
         })
        .catch(function (error) { state.isLoading = false; });
    },
    async widget({ commit })  {
        try {
          const request = await axios.get('/appointments/widget');
    
          if (request.status === 200 && request.data.success == true) {
            commit('WIDGET', request.data);
          }
        } catch (error) {}
    },
    billingDetailsModal({commit, dispatch}, data){
        commit('BILLING_DETAILS_MODAL', data);
    }
}
